import styles from './krantje.module.css'

export default () => (
    <p className={styles.p}>This should be red</p>
  )